import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.gericht} alt="app__logo" />
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans"><a href="#home">Home</a></li>
        <li className="p__opensans"><a href="https://drive.google.com/file/d/1kfHt-_UrsOPf8V0gGJ97jGwd4t0qBXHO/view?usp=sharing">Speisekarte</a></li>
        <li className="p__opensans"><a href="#about">Über uns</a></li>
        <li className="p__opensans"><a href="#contact">Kontakt</a></li>
      </ul>
      {/*<div className="app__navbar-login">
        <a href="/" className="p__opensans">Book Table</a>
      </div>*/}
      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu color="#fff" fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              <li><a href="#home" onClick={() => setToggleMenu(false)}>Home</a></li>
              <li><a href="https://drive.google.com/file/d/1kfHt-_UrsOPf8V0gGJ97jGwd4t0qBXHO/view?usp=sharing" onClick={() => setToggleMenu(false)}>Speisekarte</a></li>
              <li><a href="#about" onClick={() => setToggleMenu(false)}>Über uns</a></li>
              <li><a href="#contact" onClick={() => setToggleMenu(false)}>Kontakt</a></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
